<div class="width100 text-align-center margin-top40">
  Convert project in progress... {{ loadingStatus$ | async }}%
</div>
<div class="flex-row-center-h">
  <ion-button *ngIf="(loadingStatus$ | async)  == 100" (click)="closeModal()" size="default">
    Close
  </ion-button>
</div>
